// src/views/MaintenancePage.jsx
export default function MaintenancePage({ params }) {
  const primaryColor = params?.couleur_primaire || "#004080";
  const message = params?.message_maintenance || "Nous effectuons une maintenance. Merci de revenir dans quelques instants.";

  return (
    <div className="maintenance-page">
      <div className="maintenance-card">
        {params?.logo && (
          <img src={params.logo} alt={params.nom_plateforme || "Logo"} className="maintenance-logo" />
        )}
        <div className="maintenance-icon" style={{ background: `${primaryColor}12`, color: primaryColor }}>
          <i className="ti ti-tool" />
        </div>
        <h1>{params?.nom_plateforme || "Site en maintenance"}</h1>
        <p>{message}</p>
      </div>

      <style>{`
        @import url('https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/dist/tabler-icons.min.css');

        .maintenance-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f8fafc;
          padding: 24px;
        }

        .maintenance-card {
          max-width: 440px;
          width: 100%;
          text-align: center;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 20px;
          padding: 48px 32px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
        }

        .maintenance-logo {
          height: 40px;
          margin-bottom: 24px;
        }

        .maintenance-icon {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          margin: 0 auto 20px;
        }

        .maintenance-card h1 {
          font-size: 22px;
          font-weight: 700;
          margin: 0 0 12px;
          color: #0f172a;
        }

        .maintenance-card p {
          font-size: 15px;
          color: #64748b;
          line-height: 1.6;
          margin: 0;
        }
      `}</style>
    </div>
  );
}